import React, { memo } from 'react'
import BigNumber from './bignumbers'
import sectionStyles from '../../styles/tracker-modules/numberBreakdownSection.module.less'
import ProgressBar from './progressBar'
import { dataLabels } from './vaccine-component-helpers/dataLabels'

function NumberBreakdown({ stateData, usData }) {
  return (
    <>
      <div className={sectionStyles.container}>
        {/* <div className={sectionStyles.numberContainer}>
          <BigNumber
            number={stateData.num_pv.toLocaleString()}
            label={dataLabels['num_pv'].label}
            barStyle="pv"
          />
          <ProgressBar
            data={[{ barStyle: 'pv', val: stateData.pct_pv }]}
            total={stateData.pop}
            label={'people'}
          />{' '}
        </div>
        <div className={sectionStyles.numberContainer}>
          <BigNumber
            number={stateData.num_fv.toLocaleString()}
            label={dataLabels['num_fv'].label}
            barStyle="pvf"
          />
          <ProgressBar
            data={[{ barStyle: 'pv', val: stateData.pct_pv }, { barStyle: 'pvf', val: stateData.pct_fv }]}
            total={stateData.pop}
            label="people"
          />
        </div> */}

        <div>
          <ProgressBar
            data={[
              {
                barStyle: 'pv',
                val: stateData.pct_pv,
                label: dataLabels['num_pv'].label,
              },
              {
                barStyle: 'pvf',
                val: stateData.pct_fv,
                label: dataLabels['num_fv'].label,
              },
            ]}
            total={stateData.pop}
            label="Total population:"
            labelLocation="start"
          />
        </div>
      </div>
      <div className={sectionStyles.tableContainer}></div>

      <p className="footnote">
        Source: CDC. Population data from American Community Survey 5-year
        estimates.
        <br />
        {/* removing below since this will no longer be in the data coming in */}
        {/*}

        {stateData.o &&
          `Note: ${usData.o.toLocaleString()} doses in the United States, including ${stateData.o.toLocaleString()} doses in ${
            stateData.n
          }, have
        been reported without specification of first or second dose. `}
        
        */}
      </p>
    </>
  )
}

export default memo(NumberBreakdown)
